import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <motion.div
          className="footer-logo"
          style={{ position: 'relative' }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {/* Thin spinning ring, echoes the same motif used around the
              photo in Hero and the initials in Loader, small touch that
              ties the whole site together instead of the footer feeling
              disconnected from everything else. */}
          <motion.div
            style={{
              position: 'absolute',
              inset: '-8px',
              borderRadius: '50%',
              border: '1px dashed rgba(240,147,251,0.4)',
            }}
            animate={{ rotate: 360 }}
            transition={{ duration: 12, repeat: Infinity, ease: 'linear' }}
          />
          <span className="footer-logo-text">WA</span>
          <motion.div
            className="footer-logo-glow"
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ duration: 3, repeat: Infinity }}
          />
        </motion.div>
        <div className="footer-text">
          &copy; {new Date().getFullYear()} Waleed Abdullah. All rights reserved.
          Crafted with passion for innovation.
        </div>
      </div>
    </footer>
  );
};

export default Footer;